import React from 'react'

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      camper, // via query
      form, // via withState
      setForm, // via withState
      setFormOpen, // via withState
      validateRedeemablePass // via withMutation
    } = props

    // display the redemption form
    const handleClickRedeem = e => {
      setFormOpen(true)
    }

    const handleChangeFormField = field => e => {
      setForm({ code: e.target.value })
    }

    const handleClickSubmit = e => {
      validateRedeemablePass({
        variables: {
          camperId: camper.id,
          input: {
            code: form.code
          }
        }
      })
    }

    const handleClickCancel = e => {
      setForm({ code: '' })
      setFormOpen(false)
    }

    return (
      <WrappedComponent
        onClickRedeem={handleClickRedeem}
        onChangeFormField={handleChangeFormField}
        onClickSubmit={handleClickSubmit}
        onClickCancel={handleClickCancel}
        {...props}
      />
    )
  }
}

export default withEventHandlers
